import Hero from "../components/Hero";
import TestimonialCard from "../components/TestimonialCard";
import CTABanner from "../components/CTABanner";
import { IMAGES, TESTIMONIALS, COPY } from "../lib/_data";
import { Star, ShieldCheck, BadgeCheck, Award } from "lucide-react";

const TRUST_STATS = [
  { k: "4.9★", v: "Average rating", icon: Star },
  { k: "300+", v: "Homes served", icon: BadgeCheck },
  { k: "15 yrs", v: "Locally owned", icon: Award },
  { k: "100%", v: "Licensed & insured", icon: ShieldCheck },
];

export default function Reviews() {
  const hero = COPY.reviews.hero;
  const section = COPY.reviews.section;
  const statsCopy = COPY.reviews.stats || {};
  const finalCta = COPY.reviews.finalCta;
  const trustStats = TRUST_STATS.map((s, i) => ({
    ...s,
    k: statsCopy[`stat${i + 1}K`] || s.k,
    v: statsCopy[`stat${i + 1}V`] || s.v,
  }));
  return (
    <div data-testid="page-reviews">
      <Hero
        image={IMAGES.reviewsHero}
        eyebrow={hero.eyebrow || "Reviews & testimonials"}
        title={hero.title || "Real neighbors. Real projects. Real reviews."}
        subtitle={hero.subtitle || "We don't buy reviews and we don't cherry-pick. Every quote here is from a verified local customer."}
        primaryCta={{ label: hero.primaryCtaLabel || "Request a Quote", to: hero.primaryCtaTo || "/consultations" }}
        secondaryCta={{ label: hero.secondaryCtaLabel || "Book a Consultation", to: hero.secondaryCtaTo || "/consultations" }}
      />

      {/* Trust stats */}
      <section
        data-testid="reviews-trust-stats"
        className="bg-[#fffdf9] py-16 border-b border-[#e5e0d8]"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {TRUST_STATS.map((s, i) => (
            <div
              key={s.v}
              className="bg-[#f9f6f0] rounded-2xl p-6 border border-[#e5e0d8] text-center"
            >
              <s.icon className="w-6 h-6 text-[#c85a3c] mx-auto" strokeWidth={2.4} />
              <div className="font-display text-3xl md:text-4xl font-black text-[#2c2a29] mt-3">
                {trustStats[i].k}
              </div>
              <div className="text-xs text-[#5c5855] mt-1 font-medium">{trustStats[i].v}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#f9f6f0] py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
          <div className="max-w-2xl mb-14">
            <span className="text-xs tracking-[0.24em] uppercase font-bold text-[#c85a3c]" data-testid="reviews-section-eyebrow">
              {section.eyebrow || "What locals are saying"}
            </span>
            <h2 className="font-display text-3xl md:text-5xl font-black text-[#2c2a29] leading-[1.05] mt-4" data-testid="reviews-section-title">
              {section.title || "Trusted by 300+ households across the region."}
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...TESTIMONIALS, ...TESTIMONIALS].slice(0, 9).map((t, i) => (
              <TestimonialCard key={i} item={t} index={i} />
            ))}
          </div>
        </div>
      </section>

      <CTABanner
        image={IMAGES.finalCta}
        eyebrow={finalCta.eyebrow || "Ready when you are"}
        title={finalCta.title || "Want to be our next 5-star story?"}
        subtitle={finalCta.subtitle || "Book a free consultation — we'll show you why locals keep coming back."}
        primary={{ label: finalCta.primaryLabel || "Book a Consultation", to: finalCta.primaryTo || "/consultations" }}
        secondary={{ label: finalCta.secondaryLabel || "Request a Quote", to: finalCta.secondaryTo || "/contact" }}
      />
    </div>
  );
}
